module.exports = function() {
  return new Worker(__webpack_public_path__ + "d27b2714d9bccc553987.worker.js");
};